import TableCell from "@material-ui/core/TableCell";
import React from "react";

const PumpenwolfKdIcon = ( text: any,
                           id: any,
                           index: number,
                           VisitData: any,
                           VisitDataDel: any,
                           Store: any,
                           tableBodyPositionElement: any) => {

    return (
        <>
            <TableCell
                style={{ textAlign: tableBodyPositionElement }}
                key={'td' + id + '_' + index}
                data-param={VisitData}
                data-param-del={VisitDataDel}
                data-id={id}
                id={'td' + id + '_' + index}
            >
                {parseInt(text) === 1
                    ? <>
                        <span className="material-symbols-outlined text-warning" >
                        person_alert
                        </span>
                    </>
                    : <>
                        <span className="material-icons">
                        people
                        </span>
                    </>}

            </TableCell>
        </>
    )

}

export default PumpenwolfKdIcon;
